import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switcher-fontsize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.getFontSize === 1)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFlipResizeClick(2))),
          icon: "mdi mdi-format-font-size-increase",
          variant: "text",
          title: "Zmień rozmiar czcionki na domyślny"
        }))
      : _createCommentVNode("", true),
    (_ctx.getFontSize === 2)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFlipResizeClick(3))),
          icon: "mdi mdi-format-font-size-increase",
          variant: "text",
          title: "Zmień rozmiar czcionki na większy"
        }))
      : _createCommentVNode("", true),
    (_ctx.getFontSize === 3)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFlipResizeClick(1))),
          icon: "mdi mdi-format-font-size-decrease",
          variant: "text",
          title: "Zmień rozmiar czcionki na większy"
        }))
      : _createCommentVNode("", true)
  ]))
}